export default "__VITE_ASSET__aed50bfc__"